import { withViewModel } from '../../../../../infrastructure/components/with-view-model';
import { ConnectionGroupsListPresentation } from './connection-groups-list.presentation';
import { ConnectionGroupsListVM } from './connection-groups-list.viewmodel';
import { IConnectionDetailsDTO, IConnectionGroupDTO } from '../../../../../api/connections.dao';


type ConnectionGroupsListProps = {
    getGroups: () => IConnectionGroupDTO[];
    getConnections: () => IConnectionDetailsDTO[];
    contextParams: { meetingId?: number; roomId?: number };
    createConnectionGroup: (connectionGroup: IConnectionGroupDTO) => Promise<IConnectionGroupDTO>;
    getDefaultConnectionId?: () => number | null;
    updateDefaultConnection?: (meetingConnectionId: number | null) => void;
    editConnectionGroup: (connectionGroup: IConnectionGroupDTO) => Promise<IConnectionGroupDTO>;
    deleteConnectionGroup: (groupId: number) => Promise<void>;
};

export const ConnectionGroupsList = withViewModel(ConnectionGroupsListPresentation, (props: ConnectionGroupsListProps) => {
    const {
        getGroups,
        getConnections,
        contextParams,
        createConnectionGroup,
        getDefaultConnectionId,
        updateDefaultConnection,
        editConnectionGroup,
        deleteConnectionGroup,
    } = props;
    const vm = new ConnectionGroupsListVM(
        getGroups,
        getConnections,
        contextParams,
        createConnectionGroup,
        editConnectionGroup,
        deleteConnectionGroup,
        getDefaultConnectionId,
        updateDefaultConnection
    );
    return vm;
});
